// import { useMediaQuery } from "react-responsive";
import EmailTemplate from "../credit_invoice/components/EmailTemplate";

const DownloadPDF = ({ id, type, close = () => {} }) => {
  // const sm = !useMediaQuery({ query: "(min-width:768px)" });

  const closeModal = () => {
    close();
  };

  const finalType = type;
  const itemId = id;

  return (
    <div className="opacity-0">
      {/* {sm && finalType === "invoice" && (
        <EmailTemplate
          invoiceData={{ id: itemId }}
          closeModal={closeModal}
          isPrint={true}
        />
      )}
      {!sm && finalType === "invoice" && (
        <EmailTemplate
          isPrint={true}
          invoiceData={{ id: itemId }}
          closeModal={closeModal}
          width="w-[14.8cm]"
        />
      )} */}
      {finalType === "invoice" && (
        <EmailTemplate
          invoiceData={{ id: itemId }}
          closeModal={closeModal}
          isPrint={true}
        />
      )}
    </div>
  );
};

export default DownloadPDF;
